module.exports = __webpack_public_path__ + "media/images/solutions-form-builder-333b3015f1d5571e8a62cc2ff21ce926.svg";